
const IMAGE_BASE_URL = 'https://d1dejdv71ksru4.cloudfront.net/media/holiday/';

const imageConfig = {
    ORIGINAL_IMAGE_URL: `${IMAGE_BASE_URL}original/`,
    BANNER_IMAGE_URL: `${IMAGE_BASE_URL}1920x720/`,
    GALLERY_IMAGE_URL: `${IMAGE_BASE_URL}690x410/`,
    HOME_IMAGE_URL: `${IMAGE_BASE_URL}415x190/`,
    ITERNARY_IMAGE_URL: `${IMAGE_BASE_URL}380x285/`,
    THUMB_IMAGE_URL: `${IMAGE_BASE_URL}thumb/`,
};


export default imageConfig;
